module.exports = "<label for=\"{{id}}\">{{label}} <sup *ngIf=\"required\"> *</sup></label>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/TMB/TMB/MYTMB.UI/src/app/components/form/label/label.component.html
// module id = ../../../../../src/app/components/form/label/label.component.html
// module chunks = main